import { Heading, Pane, Card, Button, NumberedListIcon, EnvelopeIcon, UserIcon, ChevronRightIcon, ScatterPlotIcon } from 'evergreen-ui';
import { getAuth, signOut } from 'firebase/auth';
import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loading } from 'src/components';
import useRedirectIfNotAuthorized from 'src/hooks/useIsAdminWithRedirect';
import Layout from 'src/layouts/Default';
import AuthContext from 'src/providers/authProvider';
import '../styles.css'

const items = [
  {
    icon: NumberedListIcon,
    header: 'Subscribers',
    description: 'Manage subscribers',
    href: '/admin/subscribers',
  },
  {
    icon: EnvelopeIcon,
    header: 'Emails',
    description: 'Manage email drafts',
    href: '/admin/emails',
  },
  {
    icon: ScatterPlotIcon,
    header: 'Tracking',
    description: 'See email events (open only for now)',
    href: '/admin/tracking',
  },
  {
    icon: UserIcon,
    header: 'Users',
    description: 'Manage admin users',
    href: undefined,
  },
];

const ControlPanel = () => {
  const navigate = useNavigate();
  const auth = getAuth();
  const { loading } = useContext(AuthContext);
  useRedirectIfNotAuthorized('/admin/login');

  if (loading) {
    return <Loading />;
  }

  const navigateToControlPanelItem = (href) => {
    if (!href) return;
    navigate(href);
  };

  const onSignOut = async () => {
    signOut(auth);
    navigate('/');
  };

  return (
    <Layout title="Control Panel" actionButtonProps={{ onBack: onSignOut, backLabel: 'Sign out' }} maxWidth={450}>
      <Card elevation={1} width={450} maxWidth="100%" display="flex" flexDirection="row" justifyContent="center" alignItems="center" flexWrap="wrap" gap="24px">
        {items.map((item) => {
          const { icon: Icon, header, description, href } = item;
          return (
            <Card
              key={header}
              width="160px"
              height="160px"
              display="flex"
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
              textAlign="center"
              gap="12px"
              padding="12px"
            >
              <Icon size={32} color="info" />
              <Pane>
                <Heading size={500}>{header}</Heading>
                <Heading size={300}>{description}</Heading>
              </Pane>
              <Button appearance="primary" disabled={!href} iconAfter={ChevronRightIcon} onClick={() => navigateToControlPanelItem(href)}>
                Go
              </Button>
            </Card>
          );
        })}
      </Card>
    </Layout>
  );
};

export default ControlPanel;
